export default [
  {
    path: '/admin/warehourses',
    name: 'warehourse',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/warehourse/index.vue')
  },
//   {
//     path: '/admin/warehourse/create',
//     name: 'warehourse-create',
//     meta: { requiresAuth: true },
//     component: () => import('@/pages/stock/warehourse/create.vue')
//   },
]
